import { ScenarioEntity } from "../../domain/scenario.entity";
import { criteriaToDTO, dtoToCriteria } from "../../../shared/infrastructure/orchestrator.mapper";
import { createEmptyCriteria } from "../../../shared/domain/orchestratedEntity.schema";
import { Scenario } from "../../../../../gen/witbooking/backoffice/orchestrator/scenario/v1/scenario_api_pb";

export class ScenarioMapper {
  static toDomain(proto: Scenario): ScenarioEntity {
    const obj = proto.toObject();
    const criteriaDto = proto.getCriteria();

    const globalActions: Record<string, string> = {};
    for (const [key, value] of obj.actionsMap) {
      globalActions[key] = value;
    }

    return {
      id: obj.id,
      active: obj.active,
      ticker: obj.ticker,
      name: obj.name || "",
      engineMultiConfigId: obj.engineMultiConfigTicker,
      globalActions,
      criteria: criteriaDto ? dtoToCriteria(criteriaDto) : createEmptyCriteria(),
    };
  }

  static toDomainArray(protos: Scenario[]): ScenarioEntity[] {
    return protos.map(proto => ScenarioMapper.toDomain(proto));
  }

  static toProto(entity: ScenarioEntity): Scenario {
    const scenario = new Scenario();
    scenario.setId(entity.id);
    scenario.setActive(entity.active);
    scenario.setTicker(entity.ticker);
    scenario.setName(entity.name || "");
    scenario.setEngineMultiConfigTicker(entity.engineMultiConfigId || "");

    const actionsMap = scenario.getActionsMap();
    for (const [key, value] of Object.entries(entity.globalActions)) {
      actionsMap.set(key, value);
    }

    if (entity.criteria) {
      scenario.setCriteria(criteriaToDTO(entity.criteria));
    }

    return scenario;
  }
}
